import React from 'react';
import { withStyles } from '@material-ui/core/styles'
import { Field, FieldArray, reduxForm } from 'redux-form'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MobileStepper from '@material-ui/core/MobileStepper';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PrivacyPolicyLink from '../../shared/components/PrivacyPolicyLink';
import { 
  renderTextField, 
  renderRadioGroup, 
  CheckboxGroup 
} from '../../../helpers/form/renders';
import { 
  renderHeightField, 
  renderWeightField 
} from '../../../helpers/form/fields';
import { common_alertOpen } from '../../../redux/actions/commonActions';
import {
  v_required,
  v_arrayMinLength,
  v_number,
  v_height,
  v_policy
} from '../../../helpers/form/validators';
import { isMobile } from 'react-device-detect';
import AppFooterPortal from '../../shared/components/AppFooterPortal';
import AppLeftPortal from '../../shared/components/AppLeftPortal';
import { Link } from 'react-router-dom';

const validate = values => {

  const errors = {
    profile: {}
  };

  console.debug(values)

  // Step 1
  //errors.disease_type = v_required(values.disease_type);
  //if (values.disease_type === 'other') {
  //  errors.disease_type_other = v_required(values.disease_type_other);
  //}
  errors.immunosuppressive_treatment = v_required(values.immunosuppressive_treatment);
  errors.other_treatment = v_required(values.other_treatment);
  if(values.other_treatment === '1') {
    errors.other_treatment_description = v_required(values.other_treatment_description);
  }
  //errors.legal_drug = v_required(values.legal_drug);
  errors.organ_transplant = v_required(values.organ_transplant);
  errors.had_surgery = v_required(values.had_surgery);
  if (values.had_surgery === '1') {
    errors.had_surgery_description = v_required(values.had_surgery_description);
  }
  errors.cranial_trauma = v_required(values.cranial_trauma);
  //errors.contraception = v_required(values.contraception);
  //errors.skin_affection = v_arrayMinLength(1, values.skin_affection);
  /**
   * @todo Validate answers for skin affection
   */
  if (values.skin_affection_answer) {
    values.members.forEach((member, memberIndex) => {
      errors.skin_affection_answer[memberIndex] = v_required(values.skin_affection_answer[memberIndex]);
    })

  }

  // Step 2
  errors.has_allergies = v_required(values.has_allergies);
  if (values.has_allergies === '1') {
    errors.has_allergies_user_input = v_required(values.has_allergies_user_input);
  }
  errors.family_has_allergies = v_required(values.family_has_allergies);
  if (values.family_has_allergies === '1') {
    errors.family_has_allergies_user_input = v_required(values.family_has_allergies_user_input);
  }
  errors.reactions_to_insect_bites = v_required(values.reactions_to_insect_bites);
  errors.reactions_to_sun = v_required(values.reactions_to_sun);
  errors.food_allergies = v_required(values.food_allergies);
  if(values.food_allergies === '1') {
    errors.food_allergies_user_input = v_required(values.food_allergies_user_input);
  }
  errors.drug_allergies = v_required(values.drug_allergies);
  if (values.drug_allergies === '1') {
    errors.drug_allergies_user_input = v_required(values.drug_allergies_user_input);
  }
  errors.cosmetic_product_allergies = v_required(values.cosmetic_product_allergies);
  if (values.cosmetic_product_allergies === '1') {
    errors.cosmetic_product_allergies_description_product = v_required(values.cosmetic_product_allergies_description_product);
    errors.cosmetic_product_allergies_description_body_zone = v_required(values.cosmetic_product_allergies_description_body_zone);
  }
  //errors.possible_affections = v_required(values.possible_affections);
  //errors.allergic_reactions_to = v_required(values.allergic_reactions_to);

  // Step 3 
  errors.gender = v_required(values.gender);
  errors.weight = v_number(values.weight);
  errors.height = v_height(values.height);
  errors.smoking = v_required(values.smoking)
  if (values.smoking === '1') {
    errors.smoking_user_input = v_required(values.smoking_user_input);
  }
  errors.has_tattoos = v_required(values.has_tattoos);
  // if (values.has_tattoos === '1') {
  //   errors.has_tattoos_value = v_required(values.has_tattoos_value);
  // }
  errors.enrolled_in_other_center = v_required(values.enrolled_in_other_center);
  errors.social_security_affiliation = v_required(values.social_security_affiliation);

  // Step 4

  errors.health_and_care_products = v_required(values.health_and_care_products);
  if (values.health_and_care_products === '1') {
    errors.health_and_care_products_answer = v_required(values.health_and_care_products_answer);
  }
  errors.hair_removal_products = v_required(values.hair_removal_products);
  if (values.hair_removal_products === '1') {
    errors.hair_removal_zones = v_required(values.hair_removal_zones);
    errors.hair_removal_products_list = v_required(values.hair_removal_products_list);
  }
  errors.had_laser_hair_removal = v_required(values.had_laser_hair_removal);
  if (values.had_laser_hair_removal === '1') {
    errors.had_laser_hair_removal_user_input = v_required(values.had_laser_hair_removal_user_input);
  }
  errors.policies = v_policy(3, values.policies)


  return errors
}


const styles = theme => ({
  progress: {
    width: '100%',
  },
  mt20: {
    marginTop: 20
  },
  buttonIndigo: theme.custom.button.indigo,
  container: {
    maxWidth: 500,
    margin: '0 auto'
  },
  typoHeader: {
    textAlign: 'initial',
    [theme.breakpoints.up('md')]: {
      maxWidth: 500,
      margin: '15px auto'
    },
  }
});

class MedicalInformationForm extends React.PureComponent {

  state = {
    activeStep: 1,
  };

  handleNext = () => {
    if (this.props.valid) {
      this.setState(state => ({
        activeStep: state.activeStep + 1,
      }));
    } else {
      if (this.state.activeStep === 1) {
        this.props.touch('disease_type');
        this.props.touch('disease_type_other');
        this.props.touch('immunosuppressive_treatment');
        this.props.touch('other_treatment');
        this.props.touch('other_treatment_description');
        //this.props.touch('legal_drug');
        this.props.touch('organ_transplant');
        this.props.touch('had_surgery');
        this.props.touch('had_surgery_description');
        this.props.touch('cranial_trauma');
        this.props.touch('contraception');
        //this.props.touch('skin_affection');
        this.props.touch('skin_affection_answer[1]');
      }
      if (this.state.activeStep === 2) {
        this.props.touch('has_allergies');
        this.props.touch('has_allergies_user_input');
        this.props.touch('family_has_allergies');
        this.props.touch('family_has_allergies_user_input');
        this.props.touch('reactions_to_insect_bites');
        this.props.touch('reactions_to_sun');
        this.props.touch('food_allergies');
        this.props.touch('food_allergies_user_input');
        this.props.touch('drug_allergies');
        this.props.touch('drug_allergies_user_input');
        this.props.touch('cosmetic_product_allergies');
        this.props.touch('cosmetic_product_allergies_description_product');
        this.props.touch('cosmetic_product_allergies_description_body_zone');
        //this.props.touch('possible_affections');
        //this.props.touch('allergic_reactions_to');
      }
      if (this.state.activeStep === 3) {
        this.props.touch('gender');
        this.props.touch('height');
        this.props.touch('weight');
        this.props.touch('smoking');
        this.props.touch('smoking_user_input');
        this.props.touch('has_tattoos');
        // this.props.touch('has_tattoos_value');
        this.props.touch('enrolled_in_other_center');
        this.props.touch('social_security_affiliation');
      }
      if (this.state.activeStep === 4) {
        this.props.touch('health_and_care_products');
        this.props.touch('health_and_care_products_answer');
        this.props.touch('hair_removal_products');
        this.props.touch('hair_removal_zones');
        this.props.touch('hair_removal_products_list');
        this.props.touch('had_laser_hair_removal');
        this.props.touch('had_laser_hair_removal_user_input');
        this.props.touch('policies');
      }
    }
    this.scrollTop();
  };

  handleBack = () => {
    if (this.props.valid) {
      this.setState(state => ({
        activeStep: state.activeStep - 1,
      }));
      this.scrollTop();
    }
  };

  bmiCalculator(weight, height) {
    if (!height || !weight) {
      return 0;
    }

    height = parseFloat(height.replace(',','.'))
    if (height < 1) {
      this.props.dispatch(common_alertOpen('Invalid height'));
    }
    let result = weight / Math.pow(height, 2);

    return result.toFixed(2)
  }

  scrollTop() {
    var root = document.getElementById('root');
    root.scrollTop = 0;
  }

  renderYesNo(name) {
    return (
      <Grid item xs={12}>
        <Field name={name} component={renderRadioGroup} style={{display: 'block'}}>
          {this.props.common.yesno && this.props.common.yesno.map((item) =>
            <FormControlLabel 
              key={item.id} 
              control={<Radio />} 
              value={item.value} 
              label={item.value} 
              style={{
                width: '45%',
                float: 'left'
              }}
            />
          )}
        </Field>
      </Grid>
    )
  }

  renderQuestionTitle(title) {
    return (
      <Grid item xs={12}>
        <Typography variant="subheading">
          {title}
        </Typography>
      </Grid>
    )
  }

  requiredItemHandleChange = (e) => {
    let arr = document.getElementsByClassName('required_input');

    for (let i = 0; i < arr.length; i++){
      let item = arr[i];

      let el = item.querySelector('input');

      console.log(`item ${i}`, el)

    };
    console.log('requiredItemHandleChange', e.target.value);
  };

  render(){

    const { 
      handleSubmit, 
      pristine, 
      submitting, 
      classes,
      form_disease_type_value,
      form_other_treatment_value,
      form_had_surgery_value,
      form_skin_affections_value,
      form_has_allergies_value,
      form_family_has_allergies_value,
      form_food_allergies_value, 
      form_drug_allergies_value, 
      form_cosmetic_product_allergies_value,
      form_weight_value,
      form_height_value,
      form_smoking_value,
      form_tattoos_value,
      form_health_and_care_products_value,
      form_hair_removal_products_value,
      form_had_laser_hair_removal_value
    } = this.props;

    //console.debug(form_disease_type_value)

    return (
      <React.Fragment>
        {!isMobile && <AppFooterPortal />}
        {!isMobile && <AppLeftPortal/>}
      
      <form onSubmit={handleSubmit}>
        <MobileStepper
          variant="progress"
          steps={4}
          position="static"
          activeStep={this.state.activeStep}
          style={{maxWidth: '100%', marginTop: 30}}
          classes={{
            progress: classes.progress
          }}
          LinearProgressProps={{
            variant: 'determinate',
            value: Math.ceil((this.state.activeStep / 4) * 100)
          }}
        />
        <Typography variant="caption" align="right" paragraph>
          <span style={{color: 'black'}}>{this.state.activeStep}</span> / 4 
        </Typography>

        <Typography variant="title" paragraph className={classes.typoHeader}>
          Información médica 
        </Typography>

        <div className={classes.container}>

        {this.state.activeStep === 1 &&
        <Grid container spacing={8} alignItems="flex-end">

          {/* Disease types  */}
          <Grid item xs={12}>
            <Typography variant="subheading" paragraph>
              ENFERMEDADES
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Presenta o ha presentado alguna vez algún tipo de enfermedad de las que se exponen a continuación? 
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field 
              name="disease_type" 
              component={CheckboxGroup} 
              options={this.props.common.disease_type || []} 
              enableAnswer
              enabledAnswerlabel="Otras (especificar)"
              enabledAnswerAcceptedValues={[16]}
            />
            {/*}
            <Field name="disease_type" component={renderRadioGroup}>
              {this.props.common.disease_type && this.props.common.disease_type.map((item) =>
                <FormControlLabel key={item.id} control={<Radio />} value={item.value} label={item.label} />
              )}
            </Field>
            {form_disease_type_value === 'other' &&
            <Field name="disease_type_other" component={renderTextField} label='Otras (especificar)' />
            }
          */}
          </Grid>
          
          {/* Medical treatments */}
          <Grid item xs={12}>
            <Typography variant="subheading" paragraph className={classes.mt20}>
              TRATAMIENTOS O MEDICAMENTOS
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Está realizando o ha realizado alguna vez algún tratamiento inmunosupresor?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field
                name="immunosuppressive_treatment"
                component={renderRadioGroup}
                style={{display: 'block'}}
            >
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Está realizando o ha realizado algún otro tratamiento médico en los últimos 6 meses?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field
                name="other_treatment"
                component={renderRadioGroup}
                style={{display: 'block'}}
            >
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
          </Grid>
          {form_other_treatment_value === 'Sí' && 
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="subheading">
              ¿De qué tipo? Especifique la duración aproximada del tratamiento:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field name="other_treatment_description" component={renderTextField} label='Especificar' />
            </Grid>
          </React.Fragment>
          }

          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Toma de forma recurrente algún medicamento de la siguiente lista?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field 
              name="legal_drug" 
              component={CheckboxGroup} 
              options={this.props.common.legal_drug || []} 
            />

            {/* <Field name="legal_drug" component={renderRadioGroup}>
              {this.props.common.legal_drug && this.props.common.legal_drug.map((item) =>
                <FormControlLabel key={item.id} control={<Radio />} value={item.value} label={item.label} />
              )}
            </Field> */}

          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Le han realizado alguna vez un trasplante de órgano o una ablación de órgano?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field name="organ_transplant" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Le han realizado alguna intervención quirúrgica recientemente o en el último año?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field name="had_surgery" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
          </Grid>
          {form_had_surgery_value === 'Sí' && 
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="subheading">
              ¿De qué tipo y cuándo?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field name="had_surgery_description" component={renderTextField} label='Especificar' />
            </Grid>
          </React.Fragment>
          }

          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Ha tenido alguna vez un traumatismo craneal con pérdida de conocimiento prolongada?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field name="cranial_trauma" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subheading">
              Para las voluntarias de sexo femenino, ¿Utiliza medios de contracepción eficaz?
            </Typography>
            <Typography variant="caption">
              (Los hombres no responden)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field name="contraception" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
          </Grid>

          {/* Skin affections */}
          <Grid item xs={12}>
            <Typography variant="subheading" paragraph className={classes.mt20}>
              AFECCIONES CUTÁNEAS
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading">
              ¿Presenta algún tipo de las afecciones cutáneas descritas a continuación? (Marque tantas como sea necesario)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field 
              name="skin_affection" 
              component={CheckboxGroup} 
              options={this.props.common.skin_affections || []} 
              enableAnswer
            />
          </Grid>

        </Grid>
        }

        {this.state.activeStep === 2 &&
        <Grid container spacing={8} alignItems="flex-end">

          {/* Alergies  */}
          <Grid item xs={12}>
            <Typography variant="subheading" paragraph>
              ALERGIAS
            </Typography>
          </Grid>

          {this.renderQuestionTitle('¿Presenta alguna alergia documentada?')}
          <Grid item xs={12}>
            <Field name="has_allergies" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_has_allergies_value === 'Sí' &&
            <Field name="has_allergies_user_input" component={renderTextField} label='¿A qué? ' />
            }
          </Grid>

          {this.renderQuestionTitle('¿En su familia hay personas que padezcan enfermedades alérgicas?')}
          <Grid item xs={12}>
            <Field name="family_has_allergies" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_family_has_allergies_value === 'Sí' &&
            <Field name="family_has_allergies_user_input" component={renderTextField} label='¿Quién?  ' />
            }
          </Grid>

          {this.renderQuestionTitle('¿Ha tenido alguna vez reacciones importantes a picaduras de insectos?')}
          {this.renderYesNo('reactions_to_insect_bites')}

          {this.renderQuestionTitle('¿Ha tenido alguna vez reacciones importantes y/o alérgicas al sol (picazón, urticaria, granitos...)?')}
          {this.renderYesNo('reactions_to_sun')}

          {this.renderQuestionTitle('¿Ha tenido alguna vez reacciones alérgicas a algún alimento?')}
          <Grid item xs={12}>
            <Field name="food_allergies" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_food_allergies_value === 'Sí' &&
            <Field name="food_allergies_user_input" component={renderTextField} label='¿A qué alimento(s)?' />
            }
          </Grid>

          {this.renderQuestionTitle('¿Ha tenido alguna vez reacciones alérgicas a algún medicamento?')}
          <Grid item xs={12}>
            <Field name="drug_allergies" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_drug_allergies_value === 'Sí' &&
            <Field name="drug_allergies_user_input" component={renderTextField} label='¿A qué medicamento(s)?' />
            }
          </Grid>

          {this.renderQuestionTitle('¿Ha tenido alguna vez reacciones alérgicas a algún producto cosmético?')}
          <Grid item xs={12}>
            <Field name="cosmetic_product_allergies" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_cosmetic_product_allergies_value === 'Sí' &&
            <React.Fragment>
              <Field name="cosmetic_product_allergies_description_product" component={renderTextField} label='¿A qué producto(s) cosmético(s)?' />
              <Field name="cosmetic_product_allergies_description_body_zone" component={renderTextField} label='¿En qué zona del cuerpo tuvo la reacción?' />
            </React.Fragment>
            }
          </Grid>

          {this.renderQuestionTitle('¿Es usted una persona sujeta a tener...?')}
          <Grid item xs={12}>
            <Field 
              name="possible_affections" 
              component={CheckboxGroup} 
              options={this.props.common.possible_affections || []} 
              enableAnswer
              enabledAnswerlabel="¿En qué circunstancias?"
            />
          </Grid>

          {this.renderQuestionTitle('¿Ha presentado alguna vez reacciones alérgicas o reacciones adversas a alguno de los siguientes productos?')}
          <Grid item xs={12}>
            <Field 
              name="allergic_reactions_to" 
              component={CheckboxGroup} 
              options={this.props.common.allergies_product_list || []} 
            />

            {/* <Field name="allergic_reactions_to" component={renderRadioGroup}>
              {this.props.common.allergies_product_list && this.props.common.allergies_product_list.map((item) =>
                <FormControlLabel key={item.id} control={<Radio />} value={item.value} label={item.label} />
              )}
            </Field> */}
          </Grid>

        </Grid>
        }

        {this.state.activeStep === 3 &&
        <Grid container spacing={8} alignItems="flex-end">

          {this.renderQuestionTitle('Sexo')}
          <Grid item xs={12}>
            <Field name="gender" component={renderRadioGroup} style={{display: 'block'}}>
              <FormControlLabel control={<Radio />} value='1' label='Femenino' style={{width: '45%',float: 'left'}} />
              <FormControlLabel control={<Radio />} value='0' label='Masculino' style={{width: '45%',float: 'left'}} />
            </Field>
          </Grid>

          <Grid item xs={12}>
            {renderHeightField()}
          </Grid>

          <Grid item xs={12}>
            {renderWeightField()}
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subheading" paragraph className={classes.mt20}>
              BMI: {this.bmiCalculator(form_weight_value, form_height_value)} 
            </Typography>
          </Grid>

          {this.renderQuestionTitle('¿Es fumador/a?')}
          <Grid item xs={12}>
            <Field name="smoking" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_smoking_value === 'Sí' &&
            <Field name="smoking_user_input" component={renderTextField} label='¿Cuántos cigarros fuma al día?' />
            }
          </Grid>

          {this.renderQuestionTitle('¿Tiene tatuajes?')}
          <Grid item xs={12}>
            <Field name="has_tattoos" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_tattoos_value === 'Sí' &&
            <Field name="has_tattoos_value" component={renderTextField} label='Especifique en qué zona(s)' />
            }
          </Grid>

          {this.renderQuestionTitle('¿Está apuntado/a en otro centro donde realicen pruebas con productos cosméticos?')}
          {this.renderYesNo('enrolled_in_other_center')}

          {this.renderQuestionTitle('¿Está afiliado al régimen de seguridad social o seguro de salud?')}
          {this.renderYesNo('social_security_affiliation')}
          
        </Grid>
        }

        {this.state.activeStep === 4 &&
        <Grid container spacing={8} alignItems="flex-end">

          {this.renderQuestionTitle('¿Utiliza alguno de los siguientes productos?')}
          <Grid item xs={12}>
            <Field 
              name="health_and_care_products" 
              component={CheckboxGroup} 
              options={this.props.common.health_and_care_products || []} 
              enableRadioGroupAnswer
              enabledRadioGroupLabels={[
                {'id': 1, 'value': 'Ocasionalmente', 'label': 'Ocasionalmente'},
                {'id': 2, 'value': 'Habitualmente', 'label': 'Habitualmente'}
              ]}
            />
            {form_health_and_care_products_value && form_health_and_care_products_value.indexOf(46) > -1 && 
            <Field name="health_and_care_products_user_input" component={renderTextField} label='Especifique cuál' />
            }
          </Grid>

          {this.renderQuestionTitle('¿Utiliza productos para depilarse?')}
          {this.renderYesNo('hair_removal_products')}

          {form_hair_removal_products_value === 'Sí' && this.renderQuestionTitle('¿Dónde? (zona)')}
          {form_hair_removal_products_value === 'Sí' && 
          <Grid item xs={12}>

              <Field 
                name="hair_removal_zones" 
                component={CheckboxGroup} 
                options={this.props.common.hair_removal_zones || []} 
              />

              {/*<Field name="hair_removal_zones" component={renderRadioGroup} style={{display: 'block'}}>*/}

              {/*this.props.common.hair_removal_zones && this.props.common.hair_removal_zones.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.label} 
                  style={{
                    width: '100%',
                  }}
                />
              )*/}
            {/*</Field>*/}
          </Grid>
          }
          {form_hair_removal_products_value === 'Sí' && this.renderQuestionTitle('¿Qué producto?')}
          {form_hair_removal_products_value === 'Sí' && 
          <Grid item xs={12}>
              <Field 
                name="hair_removal_products_list" 
                component={CheckboxGroup} 
                options={this.props.common.hair_removal_products_list || []} 
              />
            {/*<Field name="hair_removal_products_list" component={renderRadioGroup} style={{display: 'block'}}>*/}
              {/*this.props.common.hair_removal_products_list && this.props.common.hair_removal_products_list.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.label} 
                  style={{
                    width: '100%',
                  }}
                />
              )*/}
            {/*</Field>*/}
          </Grid>
          }

          {this.renderQuestionTitle('¿Se hace o se ha hecho la depilación láser?')}
          <Grid item xs={12}>
            <Field name="had_laser_hair_removal" component={renderRadioGroup} style={{display: 'block'}}>
              {this.props.common.yesno && this.props.common.yesno.map((item) =>
                <FormControlLabel 
                  key={item.id} 
                  control={<Radio />} 
                  value={item.value} 
                  label={item.value} 
                  style={{
                    width: '45%',
                    float: 'left'
                  }}
                />
              )}
            </Field>
            {form_had_laser_hair_removal_value === 'Sí' &&
            <Field name="had_laser_hair_removal_user_input" component={renderTextField} label='Especifique en qué zona(s)' />
            }
          </Grid>

          <Grid item xs={12} style={{padding: '30px 25px 30px 25px'}}>
            <Field 
              name="policies" 
              component={CheckboxGroup} 
              className={classes.mt20}
              options={[
                {
                  id: 1, 
                  value: (
                    <Typography variant="caption">
                        Acepto las &nbsp;
                        <Typography component={Link} to='/aviso-legal' variant='caption' target="_blank" style={{display: 'inline-block'}}><strong>condiciones generales</strong></Typography>&nbsp; y apruebo el uso de datos personales
                    </Typography>
                  )
                }, 
                {
                  id: 2, 
                  value: (
                    <Typography variant="caption">
                        Acepto la &nbsp;<Typography component={Link} to='/politica-cookies' variant='caption' target="_blank" style={{display: 'inline-block'}}><strong>política de cookies</strong></Typography>
                    </Typography>
                  )
                }, 
                {
                  id: 3, 
                  value: (
                    <Typography variant="caption">
                        Sí, he leido y doy el &nbsp;
                        <Typography component={Link} to='/consentimiento-voluntarios' variant='caption' target="_blank" style={{display: 'inline-block'}}><strong>consentimiento</strong></Typography> 
                        &nbsp;para CosmoCare
                    </Typography>
                  )
                }, 
              ]} 
            />
            
          </Grid>
          

        </Grid>
        }

        <Grid container spacing={8} style={{marginTop: '10%'}}>
          <Grid item xs={6} align="center">
            <Button variant="outlined" disabled={this.state.activeStep === 1} onClick={this.handleBack}>Atrás</Button>
          </Grid>
          <Grid item xs={6} align="center">
            {this.state.activeStep < 4 &&
            <Button
                variant="contained"
                className={classes.buttonIndigo}
                disabled={pristine || submitting}
                onClick={this.handleNext}
                style={{
                  backgroundColor: this.props.valid ? 'rgba(46, 14, 253, 1)' : 'rgba(0,0,255,0.3)',
                  color: !this.props.valid && "#fff"
                }}
            >
              Siguiente
            </Button>
            }
            {this.state.activeStep === 4 &&
            <Button
                type="submit"
                variant="contained"
                className={classes.buttonIndigo}
                disabled={pristine || submitting}
                style={{
                  backgroundColor: this.props.valid ? 'rgba(46, 14, 253, 1)' : 'rgba(0,0,255,0.3)',
                  color: !this.props.valid && "#fff"
                }}
            >
              Finalizar
            </Button>
            }
          </Grid>
        </Grid>

        <Grid container spacing={8} style={{marginTop: '10%'}}>
          <Grid item xs={12} align="center">
            <PrivacyPolicyLink />
          </Grid>
        </Grid>
        </div>

      </form>
      </React.Fragment>
    )
  }
}

MedicalInformationForm = reduxForm({
  form: 'volunteerMedicalInformation',
  validate
})(MedicalInformationForm)

export default withStyles(styles)(MedicalInformationForm);


// WEBPACK FOOTER //
// ./src/modules/account/forms/MedicalInformationForm.js